/**
 * @fileoverview gRPC-Web generated client stub for customers_document_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.1
// 	protoc              v6.32.1
// source: document.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as document_pb from './document_pb'; // proto import: "document.proto"


export class DocumentEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAdd = new grpcWeb.MethodDescriptor(
    '/customers_document_endpoint.DocumentEndpoint/Add',
    grpcWeb.MethodType.UNARY,
    document_pb.AddDocumentRequest,
    document_pb.AddDocumentResponse,
    (request: document_pb.AddDocumentRequest) => {
      return request.serializeBinary();
    },
    document_pb.AddDocumentResponse.deserializeBinary
  );

  add(
    request: document_pb.AddDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<document_pb.AddDocumentResponse>;

  add(
    request: document_pb.AddDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: document_pb.AddDocumentResponse) => void): grpcWeb.ClientReadableStream<document_pb.AddDocumentResponse>;

  add(
    request: document_pb.AddDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: document_pb.AddDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_document_endpoint.DocumentEndpoint/Add',
        request,
        metadata || {},
        this.methodDescriptorAdd,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_document_endpoint.DocumentEndpoint/Add',
    request,
    metadata || {},
    this.methodDescriptorAdd);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/customers_document_endpoint.DocumentEndpoint/Update',
    grpcWeb.MethodType.UNARY,
    document_pb.UpdateDocumentRequest,
    document_pb.UpdateDocumentResponse,
    (request: document_pb.UpdateDocumentRequest) => {
      return request.serializeBinary();
    },
    document_pb.UpdateDocumentResponse.deserializeBinary
  );

  update(
    request: document_pb.UpdateDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<document_pb.UpdateDocumentResponse>;

  update(
    request: document_pb.UpdateDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: document_pb.UpdateDocumentResponse) => void): grpcWeb.ClientReadableStream<document_pb.UpdateDocumentResponse>;

  update(
    request: document_pb.UpdateDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: document_pb.UpdateDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_document_endpoint.DocumentEndpoint/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_document_endpoint.DocumentEndpoint/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/customers_document_endpoint.DocumentEndpoint/Delete',
    grpcWeb.MethodType.UNARY,
    document_pb.DeleteDocumentRequest,
    document_pb.DeleteDocumentResponse,
    (request: document_pb.DeleteDocumentRequest) => {
      return request.serializeBinary();
    },
    document_pb.DeleteDocumentResponse.deserializeBinary
  );

  delete(
    request: document_pb.DeleteDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<document_pb.DeleteDocumentResponse>;

  delete(
    request: document_pb.DeleteDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: document_pb.DeleteDocumentResponse) => void): grpcWeb.ClientReadableStream<document_pb.DeleteDocumentResponse>;

  delete(
    request: document_pb.DeleteDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: document_pb.DeleteDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_document_endpoint.DocumentEndpoint/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_document_endpoint.DocumentEndpoint/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorGenerateSecureLink = new grpcWeb.MethodDescriptor(
    '/customers_document_endpoint.DocumentEndpoint/GenerateSecureLink',
    grpcWeb.MethodType.UNARY,
    document_pb.GenerateSecureLinkRequest,
    document_pb.GenerateSecureLinkResponse,
    (request: document_pb.GenerateSecureLinkRequest) => {
      return request.serializeBinary();
    },
    document_pb.GenerateSecureLinkResponse.deserializeBinary
  );

  generateSecureLink(
    request: document_pb.GenerateSecureLinkRequest,
    metadata?: grpcWeb.Metadata | null): Promise<document_pb.GenerateSecureLinkResponse>;

  generateSecureLink(
    request: document_pb.GenerateSecureLinkRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: document_pb.GenerateSecureLinkResponse) => void): grpcWeb.ClientReadableStream<document_pb.GenerateSecureLinkResponse>;

  generateSecureLink(
    request: document_pb.GenerateSecureLinkRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: document_pb.GenerateSecureLinkResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_document_endpoint.DocumentEndpoint/GenerateSecureLink',
        request,
        metadata || {},
        this.methodDescriptorGenerateSecureLink,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_document_endpoint.DocumentEndpoint/GenerateSecureLink',
    request,
    metadata || {},
    this.methodDescriptorGenerateSecureLink);
  }

  methodDescriptorGetDocument = new grpcWeb.MethodDescriptor(
    '/customers_document_endpoint.DocumentEndpoint/GetDocument',
    grpcWeb.MethodType.UNARY,
    document_pb.GetDocumentRequest,
    document_pb.GetDocumentResponse,
    (request: document_pb.GetDocumentRequest) => {
      return request.serializeBinary();
    },
    document_pb.GetDocumentResponse.deserializeBinary
  );

  getDocument(
    request: document_pb.GetDocumentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<document_pb.GetDocumentResponse>;

  getDocument(
    request: document_pb.GetDocumentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: document_pb.GetDocumentResponse) => void): grpcWeb.ClientReadableStream<document_pb.GetDocumentResponse>;

  getDocument(
    request: document_pb.GetDocumentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: document_pb.GetDocumentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_document_endpoint.DocumentEndpoint/GetDocument',
        request,
        metadata || {},
        this.methodDescriptorGetDocument,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_document_endpoint.DocumentEndpoint/GetDocument',
    request,
    metadata || {},
    this.methodDescriptorGetDocument);
  }

  methodDescriptorGetDocuments = new grpcWeb.MethodDescriptor(
    '/customers_document_endpoint.DocumentEndpoint/GetDocuments',
    grpcWeb.MethodType.UNARY,
    document_pb.GetDocumentsRequest,
    document_pb.GetDocumentsResponse,
    (request: document_pb.GetDocumentsRequest) => {
      return request.serializeBinary();
    },
    document_pb.GetDocumentsResponse.deserializeBinary
  );

  getDocuments(
    request: document_pb.GetDocumentsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<document_pb.GetDocumentsResponse>;

  getDocuments(
    request: document_pb.GetDocumentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: document_pb.GetDocumentsResponse) => void): grpcWeb.ClientReadableStream<document_pb.GetDocumentsResponse>;

  getDocuments(
    request: document_pb.GetDocumentsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: document_pb.GetDocumentsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_document_endpoint.DocumentEndpoint/GetDocuments',
        request,
        metadata || {},
        this.methodDescriptorGetDocuments,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_document_endpoint.DocumentEndpoint/GetDocuments',
    request,
    metadata || {},
    this.methodDescriptorGetDocuments);
  }

}

